import React, { FC, useState } from 'react';

export interface Props {
  value: number;
  onChange: (val: number) => void;
  color?: string;
  count?: number;
  allowHalf?: boolean;
  fontSize: number;
  readOnlyMode?: boolean;
  style?: React.CSSProperties;
}

const StarRating: FC<Props> = ({ color, allowHalf, value, onChange, count, fontSize, readOnlyMode, style }: Props) => {
  const [hovering, setHovering] = useState<boolean>(false);
  const [rating, setRating] = useState<number>(0);
  const starsArray = [...Array(count).keys()].map((i) => i + 1);

  let visualValue = value;
  if (hovering) {
    visualValue = rating;
  }

  function updateRating(offset, star, callback) {
    if (allowHalf) {
      const ratio = offset / fontSize;
      if (ratio <= 0.5) {
        callback(star - 0.5);
      } else {
        callback(star);
      }
    } else {
      callback(star);
    }
  }
  return (
    <div
      className="d-inline-flex star-rating-container"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      style={{ pointerEvents: readOnlyMode ? 'none' : 'auto' }}
    >
      {starsArray.map((star) => {
        return (
          <div
            key={`star${star}`}
            id={`star${star}`}
            onMouseMove={(event) => {
              updateRating(event.nativeEvent.offsetX, star, setRating);
            }}
            onClick={async (event) => {
              updateRating(event.nativeEvent.offsetX, star, onChange);
            }}
          >
            <div style={{ width: fontSize }}>
              <span
                style={{
                  cursor: 'pointer',
                  fontSize: fontSize,
                  color: color,
                  display: visualValue === star - 0.5 ? 'block' : 'none',
                }}
                data-testid="test-halfstar"
                className="mdi mdi-star-half-full"
              ></span>
              <span
                style={{
                  cursor: 'pointer',
                  fontSize: fontSize,
                  color: color,
                  display: visualValue < star - 0.5 ? 'block' : 'none',
                }}
                data-testid="test-emptystar"
                className="mdi mdi-star-outline"
              ></span>
              <span
                style={{
                  cursor: 'pointer',
                  fontSize: fontSize,
                  color: color,
                  display: visualValue > star - 0.5 ? 'block' : 'none',
                  ...style,
                }}
                data-testid="test-fullstar"
                className="mdi mdi-star"
              ></span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StarRating;
